export enum GLOBAL_MEETING_SETTING_VALUE {
  ON = "ON",
  PARTIAL = "PARTIAL",
  OFF = "OFF",
}

export enum MEETING_ALARM_TARGET {
  CREATOR = "CREATOR",
  ALL = "ALL",
}
